/* eslint-disable import/prefer-default-export */
import type {
  Organization,
  OrganizationEntities,
  SubOrganization
} from '@src/redux/reducers/auth/models'
import type {
  AccountInfo,
  OrganizationInfo_IncludeAccountIdListEntry
} from '@src/endpoints/services/base.service'
import type { FilterOption } from '../models'
import { filter, forEach, map } from 'lodash'
import { isRoot } from '@src/redux/reducers/organization/helpers'

export const mapAccountToFilterOption = (
  data: AccountInfo = {} as AccountInfo,
  isSingle: boolean,
  includeAccountIds: OrganizationInfo_IncludeAccountIdListEntry = {}
): FilterOption =>
  ({
    uid: data?.uid,
    original: data,
    name: data?.account_name,
    id: data?.account_id,
    isIncludeAccount: !!includeAccountIds[data?.account_id],
    isOrganization: false,
    isSingle,
    cloud_type: data?.cloud_type
  } as FilterOption)

function getChildIds(
  data: Organization | SubOrganization = {} as Organization | SubOrganization,
  entities: OrganizationEntities = {} as OrganizationEntities
): string[] {
  const res = []
  res.push(...(data?.account_info || []))
  forEach(data?.sub_organization || [], uid => {
    const { subOrganizations = {} } = entities || {}
    const sOrgData = subOrganizations[uid]
    if (sOrgData) {
      res.push(...(getChildIds(sOrgData, entities) || []))
    }
  })
  return res
}

export const mapAOrganizationToFilterOption = (
  uid: string,
  entities: OrganizationEntities = {} as OrganizationEntities
): FilterOption => {
  const { organizations = {}, accounts = {} } = entities || {}
  const data = organizations[uid]
  const { include_account_id_list = {} } = data || {}
  if (!data) return {} as FilterOption
  const allSubIds = getChildIds(data, entities)
  const subItems = map(allSubIds || [], uid =>
    mapAccountToFilterOption(accounts[uid], false, include_account_id_list)
  )
  // removed root accounts (GCP, AZURE)
  // only includes account in Organization
  const filtredItems = filter(
    subItems || [],
    x => !isRoot(x?.original as AccountInfo) && x?.isIncludeAccount
  )

  return {
    uid: data?.organization_uid,
    original: data,
    name: data?.organization_name,
    id: data?.organization_id,
    subItems: filtredItems,
    allSubIds,
    isOrganization: true,
    isSingle: false,
    cloud_type: data?.cloud_type
  } as FilterOption
}
